import noop from 'lodash.noop'
import { pushEventAndTrack, pushProductCareLightBox } from '../../../helpers/taggingSerializer'

const extractHostAndWarranty = props => {
  const { hostPartNumber, hostPrice, productQuantity, warrantyPartNumber, warrantyAttr = {} } = props
  const { price: warrantyPrice } = warrantyAttr

  const products = [
    {
      id: hostPartNumber,
      quantity: productQuantity,
      price: hostPrice
    }
  ]

  const warrantyProduct = {
    id: warrantyPartNumber,
    quantity: productQuantity,
    price: warrantyPrice
  }
  const pushWarranty = warrantyPartNumber ? () => products.push(warrantyProduct) : noop
  pushWarranty()
  return products
}

const trackAddItemsToTrolley = props => {
  const product = extractHostAndWarranty(props)
  const event = {
    eventInfo: {
      eventName: 'addToTrolley',
      eventAction: 'Add to Trolley'
    },
    attributes: {
      product,
      clickOrigin: 'productCareLb:ATT'
    }
  }
  pushEventAndTrack(event)
}

const trackProductCareLightBoxOpen = props => () => {
  const products = extractHostAndWarranty(props)
  pushProductCareLightBox(products)
}

export { trackAddItemsToTrolley, trackProductCareLightBoxOpen, extractHostAndWarranty }
